// extracted by mini-css-extract-plugin
export var orderSummary = "_js-0";
export var showMoreLessButton = "_js-1";